import React, { ChangeEvent, useState } from 'react';
import { IconType } from 'react-icons';
import { MdLockOutline } from 'react-icons/md';

import { Icon, TextInput, Text } from '@lucidhq/lucidium';

import { TemplateQuestion } from '~/components/Shared/hooks/useFetchTemplateQuestions';

type AnchoredAnswerItemProps = {
  answerOptionIcon: IconType;
  value: string;
  answers: (string | null)[];
  index: number;
  anchoredAnswerKey: string;
  onSave: (data: Partial<TemplateQuestion>) => void;
  readOnly: boolean;
};

export const AnchoredAnswerItem = ({
  answerOptionIcon,
  value,
  answers,
  index,
  anchoredAnswerKey,
  onSave,
  readOnly
}: AnchoredAnswerItemProps) => {
  const [inputValue, setInputValue] = useState(value ?? '');

  const handleTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const copy = [...answers];

    copy.splice(index, 1, e.target.value);

    if (e.target.value !== '') {
      onSave({
        [anchoredAnswerKey]: e.target.value,
        answers: copy as string[]
      });
    }
    setInputValue(e.target.value);
  };

  return (
    <>
      <Icon as={MdLockOutline} size={22} lss={{ minWidth: '1.9rem' }} />
      <Icon as={answerOptionIcon} size={readOnly ? 16 : 18} />
      {readOnly ? (
        <Text lss={{ pl: 'xs', flex: 1 }}>{value}</Text>
      ) : (
        <TextInput
          value={inputValue}
          placeholder={inputValue}
          lss={{ ml: 'xs', width: '100%' }}
          onChange={handleTextChange}
        />
      )}
    </>
  );
};
